import template from './multiSelectCheckboxField.html';
import controller from './multiSelectCheckboxField.controller';

let component = {
  restrict: 'E',
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    field: '<',
    onUpdate: '&',
  }
};

export default component;
